import { workspacePath } from '@/components/v2-production/layout/workspace-route-builders';
import { translateLegacyNotificationDestination } from '@/components/v2-production/layout/workspace-notification-dialect';

import type { WorkspacePresentation } from '@/components/v2-production/layout/workspace-route-contract';

/**
 * The browser twin of `send-push-notification/lib/payload.ts`'s translator: a stored notification
 * `action_url` in, a navigable workspace URL out, `null` when the value is not one.
 *
 * Route identity and query dialect are resolved as two independent dimensions by
 * `translateLegacyNotificationDestination`. A path prefix is never proof that a URL is already
 * translated — `/knowledge` and `/tasks` are simultaneously historical inputs and canonical
 * destinations, so the prefix says nothing about which dialect the stored row was written with.
 *
 * The presentation is chosen by the caller, never inferred from the input. The default is the
 * permanent `/v2` compatibility form because the desktop bridge hands the result to a shell that
 * recognises only that form, matching the APNs producer; a browser click sink passes the
 * preferred presentation so the address bar lands on it directly.
 */
export function translateActionUrl(
  actionUrl: string,
  presentation: WorkspacePresentation = 'compatibility',
): string | null {
  const location = translateLegacyNotificationDestination(actionUrl);
  if (!location) {
    return null;
  }
  const pathname = workspacePath(location.destination, presentation);
  return pathname === null ? null : `${pathname}${location.search}${location.hash}`;
}
